import { useMemo } from "react";
import { useApiClient } from "../../../../lib/http";

export function useConditionsApi() {
  const httpClient = useApiClient();

  return useMemo(
    () => ({
      getConditions: async (propertyTicker: string) => {
        return httpClient.get<any>(`/api/backoffice/${propertyTicker}/conditions`);
      },
    }),
    [httpClient]
  );
}
